import { Injectable } from '@angular/core';

declare const grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class ReCaptchaService {
  siteKey = '6LfPUHUrAAAAAMBtxRXRuYWGwVT-80BvZ3IAAgXh';

  executeAction(action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(this.siteKey, { action }).then((token: string) => {
          resolve(token);
        }, (error: any) => {
          reject(error);
        });
      });
    });
  }
}
